var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplayDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 42,
    viewBox: "0 0 150 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.444 42H5.55556C2.50139 42 0 39.6362 0 36.75V5.25C0 2.36381 2.50139 2.21967e-06 5.55556 2.21967e-06H144.444C147.499 2.21967e-06 150 2.36381 150 5.25V36.75C150 39.6362 147.499 42 144.444 42Z",
    fill: "#040015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2706 10.7572C53.2706 11.634 53.0017 12.3362 52.4721 12.8598C51.8631 13.4807 51.07 13.793 50.0981 13.793C49.1691 13.793 48.376 13.4754 47.7254 12.8493C47.0734 12.2141 46.748 11.4345 46.748 10.5013C46.748 9.5681 47.0734 8.78847 47.7254 8.15847C48.376 7.52716 49.1691 7.20953 50.0981 7.20953C50.5605 7.20953 51.0014 7.30272 51.4222 7.47597C51.8416 7.65053 52.1831 7.88678 52.4304 8.17816L51.8685 8.73203C51.437 8.2346 50.8495 7.98916 50.0981 7.98916C49.4205 7.98916 48.8331 8.22016 48.3343 8.6861C47.841 9.15335 47.5936 9.75841 47.5936 10.5013C47.5936 11.2442 47.841 11.8545 48.3343 12.3217C48.8331 12.7824 49.4205 13.0187 50.0981 13.0187C50.8173 13.0187 51.4222 12.7824 51.8994 12.3165C52.214 12.008 52.3928 11.5828 52.4398 11.0394H50.0981V10.2808H53.2222C53.2599 10.4448 53.2706 10.6037 53.2706 10.7572Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2283 8.12554H55.2937V10.1205H57.9393V10.8792H55.2937V12.8742H58.2283V13.6472H54.4629V7.35248H58.2283V8.12554Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7245 13.6472H60.8938V8.12554H59.0938V7.35248H63.5259V8.12554H61.7245V13.6472Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7363 13.6472V7.35248H67.5658V13.6472H66.7363Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2402 13.6472H70.4161V8.12554H68.6094V7.35248H73.0469V8.12554H71.2402V13.6472Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4382 12.8388C80.8024 13.4754 80.0146 13.793 79.0749 13.793C78.1299 13.793 77.3421 13.4754 76.7063 12.8388C76.0718 12.2036 75.7559 11.424 75.7559 10.5013C75.7559 9.5786 76.0718 8.79897 76.7063 8.16372C77.3421 7.52716 78.1299 7.20953 79.0749 7.20953C80.0092 7.20953 80.797 7.52716 81.4329 8.16897C82.0727 8.80947 82.3887 9.58385 82.3887 10.5013C82.3887 11.424 82.0727 12.2036 81.4382 12.8388ZM77.3206 12.3112C77.7992 12.7824 78.3813 13.0187 79.0749 13.0187C79.7632 13.0187 80.3507 12.7824 80.8239 12.3112C81.3011 11.84 81.5431 11.235 81.5431 10.5013C81.5431 9.7676 81.3011 9.16253 80.8239 8.69135C80.3507 8.22016 79.7632 7.98391 79.0749 7.98391C78.3813 7.98391 77.7992 8.22016 77.3206 8.69135C76.8434 9.16253 76.6014 9.7676 76.6014 10.5013C76.6014 11.235 76.8434 11.84 77.3206 12.3112Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5547 13.6472V7.35248H84.5629L87.6978 12.2481H87.7341L87.6978 11.038V7.35248H88.5273V13.6472H87.6615L84.3787 8.5101H84.3424L84.3787 9.72548V13.6472H83.5547Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5532 22.8401C73.0272 22.8401 70.9637 24.717 70.9637 27.3066C70.9637 29.8751 73.0272 31.7717 75.5532 31.7717C78.0845 31.7717 80.148 29.8751 80.148 27.3066C80.148 24.717 78.0845 22.8401 75.5532 22.8401ZM75.5532 30.0129C74.1672 30.0129 72.9748 28.896 72.9748 27.3066C72.9748 25.6961 74.1672 24.5989 75.5532 24.5989C76.9391 24.5989 78.1369 25.6961 78.1369 27.3066C78.1369 28.896 76.9391 30.0129 75.5532 30.0129ZM65.5395 22.8401C63.0081 22.8401 60.95 24.717 60.95 27.3066C60.95 29.8751 63.0081 31.7717 65.5395 31.7717C68.0694 31.7717 70.1289 29.8751 70.1289 27.3066C70.1289 24.717 68.0694 22.8401 65.5395 22.8401ZM65.5395 30.0129C64.1521 30.0129 62.9557 28.896 62.9557 27.3066C62.9557 25.6961 64.1521 24.5989 65.5395 24.5989C66.9254 24.5989 68.1178 25.6961 68.1178 27.3066C68.1178 28.896 66.9254 30.0129 65.5395 30.0129ZM53.6236 24.2091V26.1069H58.2654C58.1297 27.1674 57.7667 27.9471 57.2102 28.4904C56.5326 29.1467 55.4774 29.8751 53.6236 29.8751C50.7669 29.8751 48.53 27.6242 48.53 24.8351C48.53 22.0461 50.7669 19.7951 53.6236 19.7951C55.1682 19.7951 56.292 20.3844 57.1214 21.1483L58.4913 19.8109C57.3311 18.7294 55.7879 17.8986 53.6236 17.8986C49.7063 17.8986 46.4141 21.0105 46.4141 24.8351C46.4141 28.6597 49.7063 31.7717 53.6236 31.7717C55.7408 31.7717 57.3311 31.0944 58.5813 29.8239C59.8625 28.5731 60.2617 26.8144 60.2617 25.3942C60.2617 24.9532 60.2241 24.5477 60.1569 24.2091H53.6236ZM102.349 25.6804C101.971 24.6816 100.806 22.8401 98.4319 22.8401C96.0793 22.8401 94.1207 24.6501 94.1207 27.3066C94.1207 29.8082 96.0592 31.7717 98.6577 31.7717C100.759 31.7717 101.971 30.5209 102.47 29.7924L100.911 28.7779C100.391 29.5207 99.6821 30.0129 98.6577 30.0129C97.6401 30.0129 96.9101 29.5575 96.4423 28.6597L102.56 26.1883L102.349 25.6804ZM96.1116 27.1674C96.0592 25.4454 97.4814 24.5634 98.5004 24.5634C99.2989 24.5634 99.9765 24.9533 100.202 25.5111L96.1116 27.1674ZM91.139 31.5H93.1501V18.375H91.139V31.5ZM87.8455 23.835H87.7783C87.3266 23.3126 86.4649 22.8401 85.3733 22.8401C83.0826 22.8401 80.9882 24.8036 80.9882 27.321C80.9882 29.8239 83.0826 31.7717 85.3733 31.7717C86.4649 31.7717 87.3266 31.2952 87.7783 30.7571H87.8455V31.3976C87.8455 33.1052 86.9112 34.0226 85.4042 34.0226C84.1755 34.0226 83.4133 33.1564 83.0987 32.4279L81.3498 33.1406C81.8539 34.3245 83.1888 35.7814 85.4042 35.7814C87.7621 35.7814 89.7517 34.4269 89.7517 31.1312V23.1118H87.8455V23.835ZM85.5454 30.0129C84.1594 30.0129 82.9993 28.8802 82.9993 27.321C82.9993 25.7473 84.1594 24.5989 85.5454 24.5989C86.9112 24.5989 87.988 25.7473 87.988 27.321C87.988 28.8802 86.9112 30.0129 85.5454 30.0129ZM111.765 18.375H106.955V31.5H108.96V26.5269H111.765C113.992 26.5269 116.177 24.9532 116.177 22.4503C116.177 19.9487 113.987 18.375 111.765 18.375ZM111.817 24.7012H108.96V20.2007H111.817C113.315 20.2007 114.17 21.4148 114.17 22.4503C114.17 23.4662 113.315 24.7012 111.817 24.7012ZM124.216 22.8152C122.766 22.8152 121.259 23.4399 120.64 24.8246L122.42 25.5531C122.803 24.8246 123.507 24.5884 124.252 24.5884C125.292 24.5884 126.348 25.1987 126.364 26.2763V26.4141C126.001 26.2093 125.224 25.9061 124.268 25.9061C122.351 25.9061 120.398 26.9364 120.398 28.8592C120.398 30.618 121.968 31.7507 123.733 31.7507C125.083 31.7507 125.827 31.1561 126.295 30.4644H126.364V31.479H128.301V26.4443C128.301 24.1172 126.521 22.8152 124.216 22.8152ZM123.974 30.0077C123.318 30.0077 122.403 29.6901 122.403 28.896C122.403 27.8801 123.543 27.4903 124.53 27.4903C125.413 27.4903 125.827 27.6806 126.364 27.9313C126.207 29.1467 125.135 30.0077 123.974 30.0077ZM135.359 23.1026L133.053 28.7923H132.984L130.601 23.1026H128.438L132.019 31.0537L129.976 35.4782H132.072L137.59 23.1026H135.359ZM117.279 31.5H119.29V18.375H117.279V31.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4987 7.91357C13.1828 8.23645 13 8.73914 13 9.39014V32.6109C13 33.2619 13.1828 33.7646 13.4987 34.0874L13.5767 34.1583L26.9041 21.1515V20.8443L13.5767 7.83745L13.4987 7.91357Z",
    fill: "url(#paint0_linear_303_2456)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3418 25.4935L26.9043 21.1557V20.8486L31.3472 16.5108L31.4467 16.5672L36.7083 19.4902C38.2099 20.3197 38.2099 21.6847 36.7083 22.5194L31.4467 25.4371L31.3418 25.4935Z",
    fill: "url(#paint1_linear_303_2456)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4478 25.4372L26.9054 21.0022L13.5 34.0918C13.9987 34.6037 14.812 34.6654 15.7369 34.1535L31.4478 25.4372Z",
    fill: "url(#paint2_linear_303_2456)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4478 16.5651L15.7369 7.84875C14.812 7.34213 13.9987 7.40381 13.5 7.91569L26.9054 21L31.4478 16.5651Z",
    fill: "url(#paint3_linear_303_2456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_2456",
    x1: 25.7208,
    y1: 32.8527,
    x2: 8.10434,
    y2: 14.8094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_2456",
    x1: 38.6636,
    y1: 21.0007,
    x2: 12.6412,
    y2: 21.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_2456",
    x1: 28.9778,
    y1: 18.5913,
    x2: 5.08841,
    y2: -5.87691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_2456",
    x1: 10.1256,
    y1: 41.815,
    x2: 20.7933,
    y2: 30.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayDesktop);
export default __webpack_public_path__ + "static/media/googleplay-desktop.9bb2cef5826d7c9b411838e78eae88d1.svg";
export { ForwardRef as ReactComponent };